// extracted by mini-css-extract-plugin
export default {"form":"form_form__v9NsD","twoFields":"form_twoFields__p8kyk","color":"form_color__c8knu"};